<!-- 轮播图  -->
<template>
  <div>
    <el-carousel style="width: 100%;margin-top:80px" height="700px">
      <el-carousel-item v-for="(item, index) in carouselList" :key="index">
        <img :src="item.cover" alt="" class="scoll-img" />
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
export default {
  data() {
    return {
      carouselList: [],
    };
  },
  created() {
    this.$http
      .adminContentPage({
        pageNum: 1,
        pageSize: 200,
        type: "ROTATION",
        enable: "YES",
      })
      .then((res) => {
        if (res.data.data.records && res.data.success) {
          this.carouselList = res.data.data.records;
        }
      });
  },
};
</script>

<style lang="less" scoped>
.scoll-img {
  width: 100%;
  height: 700px;
  object-fit: cover;
}
</style>